import { Link } from "react-router-dom";

const FOOTER_LINKS = [
  { label: "Tracksuits", to: "/tracksuits" },
  { label: "Accessories", to: "/accessories" },
  { label: "Private Access", to: "/#access" },
  { label: "Instagram", href: "#instagram" },
  { label: "Shipping", to: "/contact" },
  { label: "Returns", to: "/contact" },
  { label: "Contact", to: "/contact" },
  { label: "Imprint", href: "#imprint" },
  { label: "Privacy", href: "#privacy" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-capra-night border-t border-capra-bronze/10">
    <div className="mx-auto max-w-[1500px] px-6 lg:px-16 py-20 lg:py-28 text-center">
      <p className="font-display text-lg tracking-[0.35em] text-capra-ivory">CAPRA FALCONERI</p>
      <nav className="mt-12 flex flex-wrap justify-center gap-x-10 gap-y-4">
        {FOOTER_LINKS.map((l) =>
          l.to ? (
            <Link key={l.label} to={l.to} className="text-[10px] uppercase tracking-[0.3em] text-capra-muted hover:text-capra-bronze transition-colors">
              {l.label}
            </Link>
          ) : (
            <a key={l.label} href={l.href} className="text-[10px] uppercase tracking-[0.3em] text-capra-muted hover:text-capra-bronze transition-colors">
              {l.label}
            </a>
          )
        )}
      </nav>
      <p className="mt-16 text-[10px] uppercase tracking-[0.4em] text-capra-muted/50">© CAPRA FALCONERI</p>
    </div>
  </footer>
);
